import React from 'react'
import classNames from 'classnames'
import ContentColumn from './ContentColumn'
import { ColumnsChildrenProps } from './Columns.d'

const TwoColumnContent = ({
  columnContents = [],
  textColor,
  textAlignment,
  twoColumnOnTablet
}: ColumnsChildrenProps) => {
  const renderContents = (column: any) => {
    return column.children.map((content: any, i: number) => {
      return (
        <ContentColumn
          component={content}
          key={i}
          textColor={textColor}
          type={content.typeHandle}
        />
      )
    })
  }
  return (
    <>
      {columnContents.map((column: any, index: number) => {
        const exportClass = classNames('col-span-6 grid w-full', {
          'text-center justify-items-center': textAlignment === 'center',
          'text-left': textAlignment === 'left',
          'text-right': textAlignment === 'right',
          '[@media(min-width:992px)]:col-span-6': !twoColumnOnTablet,
          'md:col-span-6 z-10': twoColumnOnTablet,
          'order-none [@media(min-width:992px)]:order-none [@media(max-width:991px)]:justify-center':
            column.children[0].typeHandle === 'image' && !twoColumnOnTablet,
          'order-none md:order-none [@media(max-width:767px)]:justify-center':
            column.children[0].typeHandle === 'image' && twoColumnOnTablet,
          'order-1 [@media(min-width:992px)]:order-none':
            column.children[0].typeHandle !== 'image' && !twoColumnOnTablet,
          'order-1 md:order-none':
            column.children[0].typeHandle !== 'image' && twoColumnOnTablet
        })
        return (
          <div className={exportClass} key={index}>
            {renderContents(column)}
          </div>
        )
      })}
    </>
  )
}
export default TwoColumnContent
